import React from "react";
import { Link } from "react-router-dom";
import CustomImage from "./ReUse/Components/Image";

const BannerSlide = (propsData) => {
	const { id, photo, title, sub_title, description, url } = propsData ?? {};

	return (
		<div className="slider-for-pro">
			<div className="all-banenr-back">
				<div className="row">
					<div className="col-md-5">
						<div className="banenr-text">
							<h5>{title}</h5>
							<h2>{sub_title}</h2>
							<div className="discover-btn">
								<Link to={url || "/"}>Discover Now</Link>
							</div>
						</div>
					</div>
					<div className="col-md-7">
						<div className="banner-image">
							<figure>
								<CustomImage thumbnail={photo} />
							</figure>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BannerSlide;
